{
  "columnResizer": "שינוי גודל עמודה",
  "loading": "טוען...",
  "loadingMore": "טוען עוד...",
  "resizeColumn": "שנה את גודל העמודה",
  "sortAscending": "מיין בסדר עולה",
  "sortDescending": "מיין בסדר יורד"
}
